import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
/**
 * Хранит boolean стейт
 * С помощью useCallback создаются функции для установки true и false в стейт
 * */

export var useBooleanState = function useBooleanState(initialState) {
  var _React$useState = React.useState(function () {
    return initialState !== undefined ? initialState : false;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var handleSetTrue = React.useCallback(function () {
    return setState(true);
  }, []);
  var handleSetFalse = React.useCallback(function () {
    return setState(false);
  }, []);
  return [state, handleSetTrue, handleSetFalse];
};